import axios from 'axios'

const api = axios.create({
    baseURL: import.meta.env.VITE_API_URL || 'http://localhost:3667/api',
    headers: {
        'Content-Type': 'application/json',
    },
})

// Request interceptor
api.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem('token')
        if (token) {
            config.headers.Authorization = `Bearer ${token}`
        }
        return config
    },
    (error) => {
        return Promise.reject(error)
    }
)

// Response interceptor
api.interceptors.response.use(
    (response) => {
        return response
    },
    (error) => {
        // Only redirect on 401 if we're not on login-related endpoints
        if (error.response?.status === 401 && 
            !error.config?.url?.includes('/auth/login') && 
            !error.config?.url?.includes('/auth/verify-otp') &&
            !error.config?.url?.includes('/auth/resend-otp')) {
            localStorage.removeItem('token')
            window.location.href = '/login'
        }
        return Promise.reject(error)
    }
)

export default api 

// Visible cameras helper
export async function setVisibleCameras(cameraIds) {
    try {
        await api.post('/streams/visible', { cameraIds });
    } catch (e) {
        console.warn('Failed to update visible cameras:', e?.message || e);
    }
}

export async function getQueueStatus() {
    try {
        const res = await api.get('/streams/queue/status');
        return res.data?.data;
    } catch (e) {
        console.warn('Failed to fetch queue status:', e?.message || e);
        return null;
    }
}